// @ts-nocheck
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import optional from '@/components/common/Optional';

const ChangelogEntryWithoutInjection = ({ entry: { date, messages, releaseNumber, displayReleaseNumber }, intl }) => {
    // eslint-disable-next-line max-len
    const entryImageClassName =
        'margin-top-20 width-100pct border-style-solid border-width-1 border-color-lighter margin-bottom-10';

    const formattedDate = new Intl.DateTimeFormat(intl.locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }).format(new Date(date));

    return (
        <div className='form-group' data-testid='changelog-entry'>
            <h5>
                {displayReleaseNumber}
                <span className='pull-right text-color-gray'>{formattedDate}</span>
            </h5>
            <ul>
                {messages.map(message => (
                    <li
                        key={`li-${releaseNumber}-${message.text}-${message.imageUrl ?? 'no-image'}`}
                        id={`li-${releaseNumber}-${message.text}`}
                    >
                        <div>
                            <FormattedMessage id={message.text} />
                            {optional(message.imageUrl, <img className={entryImageClassName} src={message.imageUrl} />)}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

ChangelogEntryWithoutInjection.propTypes = {
    entry: PropTypes.shape({
        date: PropTypes.string.isRequired,
        messages: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string.isRequired,
                imageUrl: PropTypes.string,
            })
        ).isRequired,
        displayReleaseNumber: PropTypes.string,
        releaseNumber: PropTypes.number.isRequired,
    }).isRequired,
    intl: PropTypes.shape({
        locale: PropTypes.string.isRequired,
    }).isRequired,
};

export default injectIntl(ChangelogEntryWithoutInjection);
